// REACT
import React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// COMPONENTS
import { FluidSection } from 'components/FluidSection/index';
import { Content } from 'components/Content/index';
import { Calendar } from 'components/Calendar';
import ConfirmRebook from 'components/Dialog/ConfirmRebook';

// CONSTANTS AND UTILS
import { constants } from 'constants/index';
import { toArray } from 'utils/lodashUtils';

// VENDOR
import FlatButton from 'material-ui/FlatButton';
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import CircularProgress from 'material-ui/CircularProgress';

class RebookingCalendar extends React.Component {

    constructor () {
        super();
        this.state = {
          showConfirmRebookModal: false,
          loading: false,
          width: 0,
          height: 0,
          calendarLoading: true
        };
    }
    
    // componentWillMount() {
    //     this.updateWindowDimensions();
    //     window.addEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
    // }
    
    // componentWillUnmount() {
    //     window.removeEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
    // }
    
    componentDidMount(){
            // Recive window dimetions
            // this.updateWindowDimensions();
            // window.addEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);

            // Go to the top of the page on load
            document.getElementById('top').scrollIntoView();
            this.props.getDBProviders()
                .then((res) => {
                    this.getProviderData(this.props);
                })
                .catch(console.log);
            this.props.getDBServices();
    }

    // updateWindowDimensions = () => {
    //     this.setState({ width: window.innerWidth, height: window.innerHeight });
    // }

    // @TODO: THIS IS REALLY INEFFICIENT AND SHOULD LATER BE REFACTORED 
    getProviderData = ({ match, providers, getCalendar}) => {
        return providers.map((provider, i)=> {
            // console.log('PROVIDER @ GET PRO DATA', provider);
            
            toArray(provider.services).map(providerService => {
                // 1. LOOK THROUGH THE SERVICES EACH PRO PROVIDES
                // 2. IF THIS PROVIDER PROVIDES THE SERVICE IN THE URL SERVICE ID THEN THEY ARE THE PROVIDER
                if (providerService._id === match.params.serviceKey) {
                    console.log('GOT PROVIDER @ GET PROVIDER DATA', provider);
                    console.log('FETCHING CALENDAR DATA FOR', providerService._id);
                    toArray(this.props.services).map(service => {
                        if (service._id === providerService._id) {
                            console.log('SERVICE MATCHES AND IS:', service.SBMId);
                            
                            const { SBMId, sbmVideoServiceId } = provider;
                            // console.log('SBMId/serviceId for rebooking calendar', provider, SBMId, sbmVideoServiceId, providerService);
                            
                            getCalendar(SBMId, service.SBMId)
                            .then(() => {
                                this.setState({
                                    calendarLoading: false
                                })
                            })
                            .catch(console.log)
                            
                            return;
                        }
                        
                    })
                }
            })
        });
    }

    setBookingData = ({thisWeekStartDate, serviceId, providerId, time, date, index, selectedProviderData}) => {
        this.setState({
            booking: {
                thisWeekStartDate,
                serviceId,
                providerId,
                time,
                date,
                index,
                selectedProviderData
            }
        }, (nextState)=>{
            document.getElementById('top').scrollIntoView();
            // SHOW MODAL AND ASK ARE YOU SURE YOU WANT TO REBOOK
            this.handleShowConfirmRebookModal();
        })
    }

    handleConfirmRebook = () => {
        this.props.rebookConsult(this.state.booking, this.props.match.params.bookingKey, this.props.userId)
            .then((res) => {
                const serviceKey = this.props.match && this.props.match.params && this.props.match.params.serviceKey;
                console.log('GOING BACK REBOOK IS DONE');
                // TODO REFRESH BOOKINGS with load
                this.props.loadUpcomingDbBookings({
                    userId: this.props.userId, 
                    serviceId: serviceKey,
                    // clientUid, 
                    userType: 'client'
                })
                // this.props.history.goBack();
                
                this.props.history.push(`/service/modules/${serviceKey}`)
                this.props.updateLocation(`/service/modules/${serviceKey}`);
            })
            .catch(console.log);
            this.setState({
                loading: true
            });
    }

    handleShowConfirmRebookModal = () => {
        this.setState({
            showConfirmRebookModal: true
        });
    }
    handleCloseConfirmRebookModal = () => {
        this.setState({
            showConfirmRebookModal: false
        });
    }

    render() {
        return (
            <div style={ constants.layout.container }>
                <ConfirmRebook
                    modal={ false }
                    open={ this.state.showConfirmRebookModal }
                    handleClose={ this.handleCloseConfirmRebookModal }
                    onConfirmRebook={ this.handleConfirmRebook }
                    booking={ this.state.booking }
                />
                { !this.state.loading &&
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <FluidSection
                            style={{ marginBottom: -85 }}
                        >
                            <FlatButton
                                style={{ marginLeft: 0, marginTop: -50, marginBottom: -50 }}
                                label="BACK TO BOOKINGS"
                                primary={true}
                                onClick={ () => this.props.history.goBack() }
                                disableTouchRipple={true}
                                disableFocusRipple={true}
                                icon={<ArrowLeft />}
                            />
                        </FluidSection>
                        
                        <FluidSection
                            style={{ marginTop: 0, marginBottom: -20 }}
                        >
                            <Content style={{ marginRight: 40 }} mainTitleText={`Re-Booking Calendar`} bodyText={` Click on an available timeslot modify your consultation booking time. Use the 'Next' and 'Previous' buttons to see more available booking times.`}/>
                        </FluidSection>
                        
                        { this.state.calendarLoading &&
                            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                <CircularProgress size={ 140 } thickness={ 15 } />
                                <p style={ styles.loadingTextStyles }>LOADING CALENDAR...</p>
                            </div>
                        }
                        { !this.state.calendarLoading &&
                            <Calendar
                                setBookingData={ this.setBookingData }
                            />
                        }
                    </div>
                }
                { this.state.loading &&
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                        <CircularProgress size={ 140 } thickness={ 15 } />
                        <p style={ styles.loadingTextStyles }>REBOOKING YOUR CONSULT...</p>
                    </div>
                }
            </div>
        );
    };
    };

    const styles = {
        loadingTextStyles: {
            fontSize: constants.text.baseFontStyles.fontSize
        }
    }

    const mapStateToProps = ({provider, service, auth}) => {
        return {
            userId: auth.authData && auth.authData.id,
            providers: provider.providers,
            services: service.services,
        };
    }

export default connect(mapStateToProps, actions)(RebookingCalendar);



// WEBPACK FOOTER //
// ./src/js/containers/RebookingCalendar.jsx